export default __webpack_public_path__ + "static/media/vertical-line.031a965a.svg";